// Lead kartındaki alan sırası (kullanıcıya özel, tarayıcıda saklanır).
// Yapı: [{ category: "Genel", fields: ["name", "phone", ...] }, ...]

const KEY_PREFIX = "leadDetailLayout_";

function storageKey(table, userId) {
  return KEY_PREFIX + table + "_" + (userId || "default");
}

function load(table, userId) {
  try {
    const raw = localStorage.getItem(storageKey(table, userId));
    const parsed = raw ? JSON.parse(raw) : null;
    return Array.isArray(parsed) ? parsed : null;
  } catch (e) {
    return null;
  }
}

function save(table, userId, sections) {
  try {
    const layout = sections.map((section) => ({
      category: section.category,
      fields: section.fields.slice(),
    }));
    localStorage.setItem(storageKey(table, userId), JSON.stringify(layout));
  } catch (e) {
    // depolama kapalıysa düzen sadece bu oturumda geçerli olur
  }
}

function reset(table, userId) {
  try {
    localStorage.removeItem(storageKey(table, userId));
  } catch (e) {
    // yok say
  }
}

// fields: fields API sırasıyla [{ name, category }]
// Kayıtlı düzen varsa onu uygular; düzende olmayan yeni alanlar
// varsayılan kategorilerinin sonuna eklenir.
function build(fields, saved) {
  const defaults = [];
  const byCategory = {};
  const available = {};

  fields.forEach((field) => {
    available[field.name] = field.category;
    if (!byCategory[field.category]) {
      byCategory[field.category] = { category: field.category, fields: [] };
      defaults.push(byCategory[field.category]);
    }
    byCategory[field.category].fields.push(field.name);
  });

  if (!saved) {
    return defaults;
  }

  const placed = {};
  const sections = [];
  const sectionMap = {};

  saved.forEach((section) => {
    if (!section || sectionMap[section.category]) {
      return;
    }
    const names = (section.fields || []).filter((name) => {
      if (available[name] === undefined || placed[name]) {
        return false;
      }
      placed[name] = true;
      return true;
    });
    sectionMap[section.category] = { category: section.category, fields: names };
    sections.push(sectionMap[section.category]);
  });

  defaults.forEach((section) => {
    section.fields.forEach((name) => {
      if (placed[name]) {
        return;
      }
      if (!sectionMap[section.category]) {
        sectionMap[section.category] = { category: section.category, fields: [] };
        sections.push(sectionMap[section.category]);
      }
      sectionMap[section.category].fields.push(name);
    });
  });

  return sections;
}

export default { load, save, reset, build };
